/*
 * Copyright (c) 2019 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

export class CoreValidationKey {
  static readonly HAS_VALUE = 'kit-core/validation/has-value'; // allows empty string
  static readonly REQUIRED = 'kit-core/validation/required';
  static readonly NUMBER = 'kit-core/validation/number';
  static readonly TYPE = 'kit-core/validation/type';
  static readonly EMAIL = 'kit-core/validation/email';
  static readonly DATE = 'kit-core/validation/date';
  static readonly EQUAL = 'kit-core/validation/equal';
  static readonly NOT_EQUAL = 'kit-core/validation/not-equal';
  static readonly GREATER_THAN = 'kit-core/validation/greater-than';
  static readonly GREATER_THAN_OR_EQUAL = 'kit-core/validation/greater-than-or-equal';
  static readonly LESS_THAN = 'kit-core/validation/less-than';
  static readonly LESS_THAN_OR_EQUAL = 'kit-core/validation/less-than-or-equal';
  static readonly ITERABLE = 'kit-core/validation/iterable';
  static readonly UNIQUE = 'kit-core/validation/unique';
}
